import { render, staticRenderFns } from "./mybuyorder.vue?vue&type=template&id=279b85ae&scoped=true"
import script from "./mybuyorder.vue?vue&type=script&lang=js"
export * from "./mybuyorder.vue?vue&type=script&lang=js"
import style0 from "./mybuyorder.vue?vue&type=style&index=0&id=279b85ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279b85ae",
  null
  
)

export default component.exports